import React from 'react';
import { Card, Grid,InputAdornment, Box, CardContent, Typography, TextField, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Chip, IconButton } from '@mui/material';
import { Search as SearchIcon, FilterList as FilterIcon, Receipt as ReceiptIcon } from '@mui/icons-material';

const TransactionManagement = ({ filters }) => {
  // Mock data - replace with real data
  const transactions = [
    { id: 1, type: 'Fee', description: 'Loan origination fee', amount: 500, date: '2023-05-01' },
    { id: 2, type: 'Subscription', description: 'Premium plan renewal', amount: 100, date: '2023-05-05' }
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Transaction Management
            </Typography>
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <TextField
                placeholder="Search transactions..."
                variant="outlined"
                size="small"
                sx={{ width: 300 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
              <Button variant="outlined" startIcon={<FilterIcon />}>
                Filters
              </Button>
            </Box>

            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell align="right">Amount</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transactions.map((txn) => (
                    <TableRow key={txn.id}>
                      <TableCell>{txn.date}</TableCell>
                      <TableCell>
                        <Chip 
                          label={txn.type} 
                          size="small" 
                          color={
                            txn.type === 'Fee' ? 'primary' : 
                            txn.type === 'Subscription' ? 'secondary' : 'default'
                          }
                        />
                      </TableCell>
                      <TableCell>{txn.description}</TableCell>
                      <TableCell align="right">${txn.amount.toLocaleString()}</TableCell>
                      <TableCell>
                        <IconButton size="small">
                          <ReceiptIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default TransactionManagement;